module.exports = __webpack_public_path__ + "static/chimera_2-aca0837d994a25a8404c389bf9fc7563.jpg";